/**
 * @file 获取赞的列表
 * @author liudy
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    element_id: number;
    photo_id: string;
    page?: number;
    size?: number;
}

export const getLikeUserList = (data: IInput): Promise<IListResponse<ILikeUser>> => {
    return fetchData(Api.PHOTO_GET_LIKE_USER_LIST, data).then((res: IListResponse<ILikeUser>) => {
        return res;
    });
};
